
<div class="top-nav-strip">
  <nav class="top-nav-strip__nav" role="navigation" aria-label="Main navigation">
    <slot>
      <a
        v-for="(item, index) in items"
        :key="index"
        class="top-nav-strip__item"
        :class="{ 'top-nav-strip__item--active': item.active }"
        :href="item.href || item.to || '#'"
        :aria-current="item.active ? 'page' : undefined"
        @click="handleItemClick(item, $event)"
        @keydown.enter="handleItemClick(item, $event)"
        @keydown.space.prevent="handleItemClick(item, $event)"
      >
        <lucide-icon :name="item.icon || 'Circle'" :size="16" class="mr-1" aria-hidden="true" />
        {{ item.label }}
      </a>
    </slot>
  </nav>
</div>
